import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Storage = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Storage' {...props}>
    <path fill='none' stroke='#000000' strokeWidth='2' d='M2,5.07692308 C2,5.07692308 3.66666667,2 12,2 C20.3333333,2 22,5.07692308 22,5.07692308 L22,18.9230769 C22,18.9230769 20.3333333,22 12,22 C3.66666667,22 2,18.9230769 2,18.9230769 L2,5.07692308 Z M2,13 C2,13 5.33333333,16 12,16 C18.6666667,16 22,13 22,13 M2,7 C2,7 5.33333333,10 12,10 C18.6666667,10 22,7 22,7' />
  </StyledIcon>
);
